import _regeneratorRuntime from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as e } from "../../chunks/tslib.es6.js";
import t from "../../request.js";
import i from "../../core/Accessor.js";
import r from "../../core/Error.js";
import { HandleOwnerMixin as l } from "../../core/HandleOwner.js";
import s from "../../core/Logger.js";
import a from "../../core/LRUCache.js";
import o from "../../core/PooledArray.js";
import { onAbort as n, isAbortError as c, isAborted as h, createAbortError as p } from "../../core/promiseUtils.js";
import { waitTicks as m } from "../../core/scheduling.js";
import { objectToQuery as u } from "../../core/urlUtils.js";
import { init as f } from "../../core/watchUtils.js";
import { property as v } from "../../core/accessorSupport/decorators/property.js";
import "../../core/arrayUtils.js";
import "../../core/has.js";
import { cast as y } from "../../core/accessorSupport/decorators/cast.js";
import { subclass as b } from "../../core/accessorSupport/decorators/subclass.js";
import { tilemapDefinitionId as d, Tilemap as _ } from "./Tilemap.js";

var _g;

var w = s.getLogger("esri.layers.support.TilemapCache");

var T = _g = /*#__PURE__*/function (_l) {
  _inherits(g, _l);

  var _super = _createSuper(g);

  function g(e) {
    var _this;

    _classCallCheck(this, g);

    _this = _super.call(this, e), _this._pendingTilemapRequests = {}, _this._availableLevels = {}, _this.levels = 5, _this.cacheByteSize = 2097152, _this.request = t, _this._prefetchingEnabled = !0;
    return _this;
  }

  _createClass(g, [{
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this._tilemapCache = new a(this.cacheByteSize), this.handles.add([this.watch(["layer.parsedUrl", "layer.tileServers?", "layer.apiKey?", "layer.customParameters?"], function () {
        return _this2._initializeTilemapDefinition();
      }), f(this, "layer.tileInfo.lods", function (e) {
        return _this2._initializeAvailableLevels(e);
      }, !0)]), this._initializeTilemapDefinition();
    }
  }, {
    key: "castLevels",
    value: function castLevels(e) {
      return e <= 2 ? (w.error("Minimum levels for Tilemap is 3, but got ", e), 3) : e;
    }
  }, {
    key: "size",
    get: function get() {
      return 1 << this.levels;
    }
  }, {
    key: "fetchTilemap",
    value: function fetchTilemap(e, t, i, l) {
      var _this3 = this;

      if (!this._availableLevels[e]) return Promise.reject(new r("tilemap-cache:level-unavailable", "Level ".concat(e, " is unavailable in the service")));

      var s = this._tmpTilemapDefinition,
          a = this._tilemapFromCache(e, t, i, s);

      if (a) return Promise.resolve(a);
      var o = l && l.signal;
      return l = _objectSpread(_objectSpread({}, l), {}, {
        signal: null
      }), new Promise(function (e, t) {
        n(o, function () {
          return t(p());
        });
        var i = d(s);
        var r = _this3._pendingTilemapRequests[i];

        if (!r) {
          r = _.fromDefinition(s, l).then(function (e) {
            return _this3._tilemapCache.put(i, e, e.byteSize), e;
          });

          var _e = function _e() {
            return delete _this3._pendingTilemapRequests[i];
          };

          _this3._pendingTilemapRequests[i] = r, r.then(_e, _e);
        }

        r.then(e, t);
      });
    }
  }, {
    key: "getAvailability",
    value: function getAvailability(e, t, i) {
      if (!this._availableLevels[e]) return "unavailable";

      var r = this._tilemapFromCache(e, t, i, this._tmpTilemapDefinition);

      return r ? r.getAvailability(t, i) : "unknown";
    }
  }, {
    key: "fetchAvailability",
    value: function fetchAvailability(e, t, i, l) {
      return this._availableLevels[e] ? this.fetchTilemap(e, t, i, l).catch(function (e) {
        return e;
      }).then(function (l) {
        if (l instanceof _) {
          var _s = l.getAvailability(t, i);

          return "unavailable" === _s ? Promise.reject(new r("tile-map:tile-unavailable", "Tile is not available", {
            level: e,
            row: t,
            col: i
          })) : _s;
        }

        if (c(l)) throw l;
        return "unknown";
      }) : Promise.reject(new r("tilemap-cache:level-unavailable", "Level ".concat(e, " is unavailable in the service")));
    }
  }, {
    key: "fetchAvailabilityUpsample",
    value: function fetchAvailabilityUpsample(e, t, i, r, l) {
      var _this4 = this;

      r.level = e, r.row = t, r.col = i;
      var s = this.layer.tileInfo;
      s.updateTileInfo(r);
      var a = this.fetchAvailability(e, t, i, l).catch(function (e) {
        if (c(e)) throw e;
        if (s.upsampleTile(r)) return _this4.fetchAvailabilityUpsample(r.level, r.row, r.col, r);
        throw e;
      });
      return this._fetchAvailabilityUpsamplePrefetch(r.id, e, t, i, l, a), a;
    }
  }, {
    key: "_fetchAvailabilityUpsamplePrefetch",
    value: function () {
      var _fetchAvailabilityUpsamplePrefetch2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e, t, i, r, l, s) {
        var _this5 = this;

        var a, o, n, c, p, u, f, _loop, _h;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this._prefetchingEnabled) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                a = "prefetch-".concat(e);

                if (!this.handles.has(a)) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                o = new AbortController();
                s.then(function () {
                  return o.abort();
                }, function () {
                  return o.abort();
                });
                n = !1;
                c = {
                  remove: function remove() {
                    n || (n = !0, o.abort());
                  }
                };
                this.handles.add(c, a);
                _context.next = 12;
                return m(10, o.signal).catch(function () {});

              case 12:
                n || (n = !0, this.handles.remove(a));

                if (!h(o)) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return");

              case 15:
                p = {
                  id: e,
                  level: t,
                  row: i,
                  col: r
                }, u = _objectSpread(_objectSpread({}, l), {}, {
                  signal: o.signal
                }), f = this.layer.tileInfo;

                _loop = function _loop(_h) {
                  var e = _this5.fetchAvailability(p.level, p.row, p.col, u);

                  _g._prefetches.push(e);

                  var t = function t() {
                    _g._prefetches.removeUnordered(e);
                  };

                  e.then(t, t);
                };

                for (_h = 0; _g._prefetches.length < _g._maxPrefetch && f.upsampleTile(p); ++_h) {
                  _loop(_h);
                }

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _fetchAvailabilityUpsamplePrefetch(_x, _x2, _x3, _x4, _x5, _x6) {
        return _fetchAvailabilityUpsamplePrefetch2.apply(this, arguments);
      }

      return _fetchAvailabilityUpsamplePrefetch;
    }()
  }, {
    key: "_initializeTilemapDefinition",
    value: function _initializeTilemapDefinition() {
      var e;
      if (!this.layer.parsedUrl) return;
      var _this$layer = this.layer,
          t = _this$layer.parsedUrl,
          i = _this$layer.apiKey,
          r = _this$layer.customParameters;
      this._tilemapCache.clear(), this._tmpTilemapDefinition = {
        service: {
          url: t.path,
          query: u(_objectSpread(_objectSpread(_objectSpread({}, t.query), r), {}, {
            token: null != i ? i : null == (e = t.query) ? void 0 : e.token
          })),
          tileServers: this.layer.tileServers,
          request: this.request,
          type: this.layer.type
        },
        width: this.size,
        height: this.size,
        level: 0,
        row: 0,
        col: 0
      };
    }
  }, {
    key: "_tilemapFromCache",
    value: function _tilemapFromCache(e, t, i, r) {
      r.level = e, r.row = t - t % this.size, r.col = i - i % this.size;
      var l = d(r);
      return this._tilemapCache.get(l);
    }
  }, {
    key: "_initializeAvailableLevels",
    value: function _initializeAvailableLevels(e) {
      var _this6 = this;

      this._availableLevels = {}, e && e.forEach(function (e) {
        return _this6._availableLevels[e.level] = !0;
      });
    }
  }, {
    key: "test",
    get: function get() {
      var e = this;
      return {
        get prefetchingEnabled() {
          return e._prefetchingEnabled;
        },

        set prefetchingEnabled(t) {
          e._prefetchingEnabled = t;
        },

        hasTilemap: function hasTilemap(t, i, r) {
          return !!e._tilemapFromCache(t, i, r, e._tmpTilemapDefinition);
        }
      };
    }
  }]);

  return g;
}(l(i));

T._maxPrefetch = 4, T._prefetches = new o({
  initialSize: _g._maxPrefetch
}), e([v({
  constructOnly: !0,
  type: Number
})], T.prototype, "levels", void 0), e([y("levels")], T.prototype, "castLevels", null), e([v({
  readOnly: !0,
  type: Number
})], T.prototype, "size", null), e([v({
  constructOnly: !0,
  type: Number
})], T.prototype, "cacheByteSize", void 0), e([v({
  constructOnly: !0
})], T.prototype, "layer", void 0), e([v({
  constructOnly: !0
})], T.prototype, "request", void 0), T = _g = e([b("esri.layers.support.TilemapCache")], T);
export { T as TilemapCache };